// AwardsPage.js
import React from 'react';

import AwardFeed from './AwardFeed';

import './Spending.css';

/**
 * AwardsPage
 *
 * The full new-awards feed, at /us/spending-dashboard/awards. The spending
 * dashboard shows only the first two awards and a See all button that opens
 * this page, on the same Newest / Largest and kind-of-award tabs (read from
 * ?feed= and ?group=). Here the list pages with Load more and ends with the
 * API's notes on reporting lags.
 *
 * The column matches the dashboard's: 15px sides on a phone, a centered 748px
 * column (700px of content) on desktop. The top bar titles the page "New
 * awards" and the bottom bar leaves out its search row; the Spending tab stays
 * lit because the path sits under /us/spending-dashboard.
 */
function AwardsPage() {
  return (
    <div className="awards-page">
      <AwardFeed />

      <style>{`
        .awards-page {
          padding: 8px 15px 24px;
        }
        @media screen and (min-width: 768px) {
          .awards-page {
            max-width: 748px;
            margin-left: auto;
            margin-right: auto;
            padding: 8px 24px 24px;
            box-sizing: border-box;
          }
        }
      `}</style>
    </div>
  );
}

export default AwardsPage;